module.exports = __webpack_public_path__ + "img/uploadicon.99ec9522.svg";